export interface BibliographySetAutoOrderInfoUpdateRequest {
  id: number
  autoOrders: {
    orderBranchCode: string
    orderNumber: number
    traderCode: string
    acceptType: string
    buyDepartmentCode: string
    donatedNumber: number
    donorCode: string
    budgetYear: number
    budgetBranchCode: string
    budgetDepartmentCode: string
    budgetItem: string
    equipType: string
    collectionType: string
    shelfType: string
    handlingType: string
    storeType: string
    storingLimitCode: string
    mark: string
    ndc: string
    book: string
    sub: string
    revision: number
  }[]
}

export function BibliographySetAutoOrderInfoUpdateRequestToJSON(
  value: BibliographySetAutoOrderInfoUpdateRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    auto_orders:
      value.autoOrders.length > 0
        ? value.autoOrders.map(autoOrder => ({
            order_branch_code:
              autoOrder.orderBranchCode !== ''
                ? autoOrder.orderBranchCode
                : undefined,
            order_number:
              autoOrder.orderNumber !== 0 ? autoOrder.orderNumber : undefined,
            trader_code:
              autoOrder.traderCode !== '' ? autoOrder.traderCode : undefined,
            accept_type:
              autoOrder.acceptType !== '' ? autoOrder.acceptType : undefined,
            buy_department_code:
              autoOrder.buyDepartmentCode !== ''
                ? autoOrder.buyDepartmentCode
                : undefined,
            donated_number:
              autoOrder.donatedNumber !== 0
                ? autoOrder.donatedNumber
                : undefined,
            donor_code:
              autoOrder.donorCode !== '' ? autoOrder.donorCode : undefined,
            budget_year:
              autoOrder.budgetYear !== 0 ? autoOrder.budgetYear : undefined,
            budget_branch_code:
              autoOrder.budgetBranchCode !== ''
                ? autoOrder.budgetBranchCode
                : undefined,
            budget_department_code:
              autoOrder.budgetDepartmentCode !== ''
                ? autoOrder.budgetDepartmentCode
                : undefined,
            budget_item:
              autoOrder.budgetItem !== '' ? autoOrder.budgetItem : undefined,
            equip_type:
              autoOrder.equipType !== '' ? autoOrder.equipType : undefined,
            collection_type:
              autoOrder.collectionType !== ''
                ? autoOrder.collectionType
                : undefined,
            shelf_type:
              autoOrder.shelfType !== '' ? autoOrder.shelfType : undefined,
            handling_type:
              autoOrder.handlingType !== ''
                ? autoOrder.handlingType
                : undefined,
            store_type:
              autoOrder.storeType !== '' ? autoOrder.storeType : undefined,
            storing_limit_code:
              autoOrder.storingLimitCode !== ''
                ? autoOrder.storingLimitCode
                : undefined,
            mark: autoOrder.mark !== '' ? autoOrder.mark : undefined,
            ndc: autoOrder.ndc !== '' ? autoOrder.ndc : undefined,
            book: autoOrder.book !== '' ? autoOrder.book : undefined,
            sub: autoOrder.sub !== '' ? autoOrder.sub : undefined,
            revision: autoOrder.revision !== 0 ? autoOrder.revision : undefined
          }))
        : undefined
  }
}
